<template>
<div class="pp-content pp-content--centered">
    <div @click="$root.mobileBack()" v-if="$root.view == 'mobile'" class="pp-mobile-back">
        <i class="fa fa-fw fa-angle-left"></i>
    </div>
    <div class="pp-not-found">
        <div class="pp-not-found__header">
            There doesn't seem to be anything here.
        </div>
        <div class="pp-not-found__description">
            <span>You appear to have taken a wrong turn. Please use your browser's back button or </span>
            <router-link to="/browse">start browsing.</router-link>
        </div>
    </div>
</div>
</template>


<script>
export default {
    name: 'not-found'
};
</script>



// WEBPACK FOOTER //
// NotFound.vue?222c81f0